import React, { Component } from "react";
import PropTypes from "prop-types";
import * as color from "../../constants/color";
import * as routeHelpers from "../../lib/routeHelpers";
import * as texchangePropTypes from "../../texchangePropTypes";
import PageTitle from "../text/PageTitle";
import logger from "../../lib/logger";
import backCircle from "../../images/SVGs/BackCircle.svg";
import ActionButton from "../ActionButton";
import ReQuoteButton from "../ReQuoteButton";
import { StyleSheet, css } from "aphrodite";
import QuoteSteps from "../QuoteSteps";
import FindCreateGroup from "../quote/FindCreateGroup";
import Census from "../quote/Census";
import Modal from "../Modal";
import ProposalBuilder from "../proposal-builder";
import describeNetworkError from "../../lib/describeNetworkError";
import { connect } from "react-redux";
import * as proposalActions from "../../actions/proposalActions";
import * as quoteApi from "../../lib/api/quotes";
import * as censusApi from "../../lib/api/census";
import * as employerApi from "../../lib/api/employer";
import * as brokersApi from "../../lib/api/brokers";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const styles = StyleSheet.create({
    content: {
        paddingRight: 10,
        paddingBottom: 80,
        ":after": {
            content: '""',
            display: "table",
            clear: "both",
        },
    },
    quoteForm: {
        minHeight: 500,
    },
    contentSection: {
        width: "100%",
        padding: 0,
        backgroundColor: color.white,
        borderTop: `8px solid ${color.mediumRed}`,
        marginBottom: 20,
        paddingBottom: 10,
    },
    title: {
        fontSize: 20,
        fontWeight: 500,
        paddingBottom: 0,
        marginBottom: 4,
    },
    titleSection: {
        heigth: 64,
    },
    headerSection: {
        paddingTop: 20,
    },
    backButtonContainer: {
        position: "absolute",
        marginTop: -10,
    },
    backButtonImage: {
        display: "block",
    },
    backButton: {
        position: "relative",
        top: 32,
        cursor: "pointer",
        border: "none",
        backgroundColor: "transparent",
        display: "block",
        left: 36,
        marginRight: 16,
        outline: "none",
    },
    check: {
        position: "absolute",
        top: -2,
        left: 0,
        marginRight: 10,
    },
    groupNameText: {
        color: color.darkestGray,
        fontSize: 20,
        fontWeight: 300,
    },
    enrollingText: {
        color: color.darkestGray,
        fontSize: 20,
        fontWeight: 800,
    },
    titleLink: {
        color: color.mediumYellow1,
    },
    buttons: {},
    reQuote: {
        float: "right",
        cursor: "pointer",
        marginTop: 18,
        marginRight: 24,
    },
    modalContent: {
        minWidth: 550,
        overflowY: "auto",
    },
    modalInstructions: {
        color: color.darkestGray,
        fontSize: 16,
        marginBottom: 8,
        textAlign: "center",
    },
    modalTableContainer: {
        marginBottom: 8,
        maxHeight: 600,
    },
    modalButtonContainer: {
        marginTop: 24,
        display: "flex",
        justifyContent: "space-between",
    },
    modalCloseContainer: {
        position: "absolute",
        top: 3,
        right: 3,
    },
    modalButton: {
        width: 150,
    },
    table: {
        width: "100%",
        marginTop: 0,
        marginBottom: 10,
        borderCollapse: "collapse",
        fontSize: 14,
    },
    tableFirstColumn: {
        paddingLeft: 26,
    },
    tableHeader: {
        color: color.mediumYellow1,
        fontWeight: 500,
        paddingLeft: 6,
        paddingRight: 6,
        paddingTop: 12,
        paddingBottom: 12,
        whiteSpace: "nowrap",
        borderBottom: `1px solid ${color.mediumGray}`,
        borderTop: `1px solid ${color.darkGray2}`,
    },
    tableRow: {
        color: color.tableText,
        padding: "12px 6px",
        borderBottom: `1px solid ${color.tableBorder}`,
    },
    dependentStatusContainer: {
        display: "flex",
        alignItems: "center",
        gap: 8,
    },
    dependentStatusLabel: {
        fontSize: 14,
        color: color.tableText,
        lineHeight: "16px",
        fontWeight: 500,
        whiteSpace: "nowrap",
    },
    noWrap: {
        whiteSpace: "nowrap",
    },
    greenBar: {
        borderLeft: `4px solid ${color.mediumRed}`,
        fontWeight: 500,
    },
    blueBar: {
        borderLeft: `4px solid ${color.borderBackgroundGray}`,
    },
});

const strings = {
    quote: "Quote",
    newQuote: "New Quote",
    reQuote: "Re Quote",
    reQuoteComment:
        "You are about to re-quote this Group because you need to change the Census, SIC code or Zip Code for the group.  All generated proposals will no longer be valid.",
    reQuoteQuestion: "Would you like to proceed?",
    cancelButtonText: "Cancel",
    yesButtonText: "Yes",
    closeButtonText: "Close",
};

export class QuoteEditScreen extends Component {
    static propTypes = {
        location: texchangePropTypes.location.isRequired,
        history: texchangePropTypes.history.isRequired,
        match: texchangePropTypes.match,
        me: texchangePropTypes.me.isRequired,
        setQuote: PropTypes.func.isRequired,
        setSpreadsheets: PropTypes.func.isRequired,
        setSelectedPlans: PropTypes.func.isRequired,
    };

    state = {
        step: 0,
        subStep: 0,
        quote: {},
        employerId: 0,
        loading: true,
        isSaving: false,
        isSubmittingCensus: false,
        errors: {},
        showReQuoteModal: false,
        showCensusModal: false,
        isReQuote: false,
        counties: [],
    };

    componentDidMount() {
        //Check if loading for re-quote
        if (this.props.location.search === "?r") {
            this.setState({
                subStep: 0,
                isReQuote: true,
            });
        }
        //Check if coming from Group screen
        if (this.props.location.search.startsWith("?g")) {
            const params = new URLSearchParams(this.props.location.search);
            let gpId = params.get("g");
            if (!Number.isInteger(gpId)) {
                this.setState({
                    subStep: 0,
                    employerId: gpId,
                });
            }
        }
        if (this.props.match.params.id) {
            quoteApi.getById(this.props.match.params.id).then(quote => {
                if (quote) {
                    this.props.setQuote(quote);
                    this._resetSelectedPlansAndSpreadsheets();

                    let step = 0;
                    //move to prop builder if quoted, unless re-quoting
                    if (quote.censusSize > 0 && !this.state.isReQuote) {
                        step = 2;
                    }

                    this.setState({
                        quote: quote,
                        step,
                        loading: false,
                    });
                } else {
                    setTimeout(() => {
                        this.props.history.push(routeHelpers.quotes());
                    }, 1000);
                }
            });
        } else {
            this.setState({ loading: false });
        }
    }

    _getEmployeeHomeZipForRow = (censusRows, row) => {
        if (!row || row.relationship === "EE") {
            return (row && row.homePostalCode) || "";
        }

        const sequencePrefix = row.sequenceNumber
            ? row.sequenceNumber.toString().split(".")[0]
            : null;

        if (!sequencePrefix) {
            return row.homePostalCode || "";
        }

        const employeeRow = (censusRows || []).find(
            cen =>
                cen.relationship === "EE" &&
                cen.sequenceNumber &&
                cen.sequenceNumber.toString() === sequencePrefix,
        );

        return (employeeRow && employeeRow.homePostalCode) || row.homePostalCode || "";
    };

    _onBackButtonClick = () => {
        const { step } = this.state;
        if (step === 0) {
            this.props.history.goBack();
        } else {
            this.setState({ step: step - 1 });
        }
    };

    _saveQuote = saveQuote => {
        const { me } = this.props;
        const { quote, isReQuote } = this.state;
        //help with insert/update
        if (quote && quote.id) {
            saveQuote.id = quote.id;
        }
        //ReQuote
        if (isReQuote) {
            saveQuote.isReQuote = true;
            saveQuote.parentQuoteId = quote.parentQuoteId;
        }

        //Check the zip code...  if we haven't already chosen a county.
        if (saveQuote.postalCode && !saveQuote.countyId) {
            //Need to check the zip code entered...  make sure there aren't multiple counties
            employerApi.checkZip(saveQuote.postalCode, "-1").then(response => {
                if (response && response.success) {
                    //continue to save
                    if (
                        me.regionalOfficeId === 1 &&
                        (saveQuote.selectedCarrierIds.indexOf("1") > -1 ||
                            saveQuote.selectedCarrierIds.indexOf("16") > -1 ||
                            saveQuote.selectedCarrierIds.indexOf("126") > -1)
                    ) {
                        this._saveQuoteCheckDFW(saveQuote);
                    } else {
                        this._saveQuoteFinal(saveQuote);
                    }
                } else if (
                    response &&
                    !response.success &&
                    response.message &&
                    response.message.startsWith("multiple")
                ) {
                    const countiesJSON = JSON.parse(response.message.split("|")[1]);
                    if (quote.county !== null && quote.county !== undefined) {
                        countiesJSON.forEach(c => {
                            if (c.name.startsWith(quote.county)) {
                                saveQuote.countyId = c.id.toString();
                            }
                        });
                        toast.info(
                            "We auto-selected the same county on this multi-county zip. You can adjust the selected county (if needed) before proceeding.",
                            { toastId: 1 },
                        );
                    } else {
                        toast.warning(
                            "The multi-county zip code that you entered requires you to choose a county before proceeding.",
                            { toastId: 1 },
                        );
                    }
                    //set
                    this.setState({
                        counties: countiesJSON,
                    });
                } else if (response && !response.success && response.message) {
                    toast.warning(response.message, { toastId: 1 });
                }
            });
        } else if (saveQuote.postalCode && saveQuote.countyId) {
            if (
                me.regionalOfficeId === 1 &&
                (saveQuote.selectedCarrierIds.indexOf("1") > -1 ||
                    saveQuote.selectedCarrierIds.indexOf("16") > -1 ||
                    saveQuote.selectedCarrierIds.indexOf("126") > -1)
            ) {
                this._saveQuoteCheckDFW(saveQuote);
            } else {
                this._saveQuoteFinal(saveQuote);
            }
        }
    };

    _saveQuoteCheckDFW = saveQuote => {
        //DFW "logic" for UHC Fully Insured / Level Funded versus UHC from Ideon in West Test
        //Get the Broker's countyID(s) and compare to West Texas county list
        brokersApi.getById(saveQuote.brokerId).then(response => {
            let canQuoteDirect = false;
            if (response.countyIDs && response.countyIDs.length > 0) {
                //before January 1, 2027 effectives you could only quote in these West Texas counties
                if (new Date(saveQuote.effectiveDate) < new Date("2027-01-01"))
                {
                    //West Texas fipsCodes allowed to quote UHC FI and LF with direct API
                    const westTX = [
                        "48003","48009","48011","48017","48023","48033","48043","48045","48049","48059","48065","48069","48075","48077",
                        "48079","48081","48083","48087","48095","48101","48103","48105","48107","48109","48111","48115","48117","48125",
                        "48129","48133","48135","48141","48151","48153","48155","48165","48169","48173","48179","48189","48191","48195",
                        "48197","48205","48207","48211","48219","48227","48229","48233","48235","48237","48243","48253","48263","48267",
                        "48269","48275","48279","48295","48301","48303","48305","48307","48309","48317","48319","48327","48329","48333",
                        "48335","48341","48345","48353","48357","48359","48369","48371","48375","48377","48381","48383","48389","48393",
                        "48399","48411","48413","48415","48417","48421","48429","48431","48433","48435","48437","48441","48443","48445",
                        "48447","48451","48461","48465","48475","48483","48485","48487","48495","48501","48503",
                    ];
                    //match?
                    let split = response.countyIDs.split(",");
                    for (let i = 0; i < split.length; i++) {
                        //contain?
                        if (westTX.indexOf(split[i]) > -1) {
                            canQuoteDirect = true;
                            break;
                        }
                    }
                } else {
                    //January 1, 2027 and forward can quote anywhere except these 20 counties
                    const northTX = [
                        "48085","48093","48113","48121","48139","48143","48193","48217","48221","48231","48251","48257","48337","48349",
                        "48363","48367","48397","48425","48439","48497",
                    ];
                    //match?
                    let split = response.countyIDs.split(",");
                    for (let i = 0; i < split.length; i++) {
                        //contain?
                        if (northTX.indexOf(split[i]) > -1) {
                            canQuoteDirect = false;
                            break;
                        }
                        canQuoteDirect = true;
                    }
                }
            } else if (saveQuote.selectedCarrierIds.indexOf("1") > -1 || saveQuote.selectedCarrierIds.indexOf("16") > -1) {
                toast.error(
                    "UnitedHealthcare (UHC Fully Insured) and UHC Level Funded quoting require a broker record with a valid postal code and a valid NPN.  You can try to quote through Ideon using the 'UHC (DFW)' selection using this broker.  Please adjust your carrier selections before proceeding.",
                );
                return;
            }
            //If user has chosen UHC FI (1) or UHC LF (16) AND they are NOT in West Texas OR if user has chosen UHC (DFW) [Ideon] and they are in West Texas, then alert them
            if (!canQuoteDirect && (saveQuote.selectedCarrierIds.indexOf("1") > -1 || saveQuote.selectedCarrierIds.indexOf("16") > -1)) {
                toast.error(
                    "UnitedHealthcare (UHC Fully Insured) and UHC Level Funded quoting are not available in this broker's county.  You can only quote through Ideon using the 'UHC (DFW)' selection.  Please adjust your carrier selections before proceeding.",
                );
                return;
            } else if (canQuoteDirect && saveQuote.selectedCarrierIds.indexOf("126") > -1) {
                toast.error(
                    "UnitedHealthcare (UHC Fully Insured) is available in this broker's county.  Please use 'UnitedHealthcare' for this quote and remove the 'UHC (DFW)' selection, which uses Ideon.  Please adjust your carrier selections before proceeding.",
                );
                return;
            } else {
                this._saveQuoteFinal(saveQuote);
            }
        });
    };

    _saveQuoteFinal = saveQuote => {
        //fix for date/timezone
        const dt = new Date(saveQuote.effectiveDate);
        const year = dt.getFullYear();
        const month = dt.getMonth() + 1;
        const day = dt.getDate();
        const effectiveDateOnly = `${year}-${month
            .toString()
            .padStart(2, "0")}-${day.toString().padStart(2, "0")}T00:00:00.000Z`;

        // If do this then get warning saving string back to date:
        // saveQuote.effectiveDate = effectiveDateOnly;
        // Use a copy so we don't mutate the caller's inputs object
        const saveQuoteCopy = Object.assign({}, saveQuote, { effectiveDate: effectiveDateOnly });

        //saving
        this.setState({ isSaving: true });
        quoteApi
            .saveQuote(saveQuoteCopy)
            .then(response => {
                this.props.setQuote(response);
                this.setState({
                    quote: response,
                    step: 1,
                });
                this.props.history.push(routeHelpers.editQuote(response.id));
            })
            .catch(err => {
                logger.warn(err);
                let errors = {};
                if (err && err.response) {
                    const { response } = err;
                    if (
                        response &&
                        response.data &&
                        response.data.errors &&
                        Object.keys(response.data.errors).length > 0
                    ) {
                        // Server provided validation messages
                        errors = response.data.errors;
                    } else {
                        // 500 or something else unexpected
                        const description = describeNetworkError(err);
                        toast.error(description.join("\n"), { toastId: 4 });
                    }
                }
                this.setState({ errors });
            })
            .finally(() => this.setState({ isSaving: false }));
    };

    _resetSelectedPlansAndSpreadsheets = () => {
        this.props.setSpreadsheets({
            singlePlan: [],
            multiPlan: [],
            stackedMultiPlan: [],
            automatic: [],
        });
        //Clear selected for new or requote.  Requotes will re-slect matching from parent's last proposal
        this.props.setSelectedPlans({ medical: [], dental: [], vision: [], life: [] }, [], null);
    };

    _uploadCensus = (
        censusUploadFile,
        manualCensus,
        currentMedicalBasePlanId = null,
        currentMedicalMappedPlans = [],
        currentPlansRateType = null,
    ) => {
        this.setState({ isSubmittingCensus: true });
        const { step, quote } = this.state;
        const isCensusConfirmed = !censusUploadFile;
        const quoteId = this.state.quote.id;

        const useQuoteCensus = quote.census && quote.census.length > 0;
        const censusToSend = useQuoteCensus ? quote.census : manualCensus;
        const basePlanIdToSend = useQuoteCensus
            ? quote.currentMedicalBasePlanId || null
            : currentMedicalBasePlanId || null;
        const currentPlansToSend = quote.currentPlans || [];

        censusApi
            .uploadCensus(
                quoteId,
                null,
                null,
                censusUploadFile,
                censusToSend,
                basePlanIdToSend,
                currentMedicalMappedPlans,
                currentPlansRateType || quote.currentPlansRateType || null,
                currentPlansToSend,
            )
            .then(response => {
                if (response.success) {
                    //We don't save at the initial upload census point...  we ask the user to confirm the census.
                    if (!isCensusConfirmed && response && response.census) {
                        quote.census = response.census;
                        quote.currentPlans = response.currentPlans || [];
                        quote.mappedPlans =
                            response.mappedPlans || response.currentMedicalMappedPlans || null;
                        quote.currentPlansRateType = response.currentPlansRateType || null;
                        quote.currentMedicalBasePlanId = response.currentMedicalBasePlanId || null;
                    }
                    toast.success(response.message, { toastId: 1 });
                    this.setState({ isSubmittingCensus: false });

                    //if we called the API's /census/upload-manual-census endpoint then we continue on:
                    if (isCensusConfirmed) {
                        quoteApi
                            .submitQuote(quoteId)
                            .then(quoteResponse => {
                                this.props.setQuote(quoteResponse);
                                this._resetSelectedPlansAndSpreadsheets();
                                this.setState({
                                    quote: quoteResponse,
                                    step: step + 1,
                                    censusUpload: null,
                                    isSubmittingCensus: false,
                                    isReQuote: false,
                                });
                            })
                            .catch(err => {
                                if (err && err.response && err.response.data) {
                                    toast.error(err.response.data, { toastId: 2 });
                                } else if (err && err.response) {
                                    toast.error(err.response, { toastId: 2 });
                                }
                            });
                    }
                } else {
                    //There was an error during upload...
                    if (response && response.census) {
                        quote.census = response.census;
                    }
                    quote.currentPlans = (response && response.currentPlans) || [];
                    quote.mappedPlans =
                        (response &&
                            (response.mappedPlans || response.currentMedicalMappedPlans)) ||
                        null;
                    quote.currentPlansRateType =
                        (response && response.currentPlansRateType) || null;
                    quote.currentMedicalBasePlanId =
                        (response && response.currentMedicalBasePlanId) || null;
                    if (response && response.message) {
                        quote.censusUploadErrors = response.message;
                        toast.error(
                            "There were some problems with your census.  Please fix and resubmit.",
                            { toastId: 3 },
                        );
                    } else if (response && response.data) {
                        toast.error(response.data, { toastId: 3 });
                    }
                    this.setState({ isSubmittingCensus: false });
                }
            });
    };

    _copyCensus = () => {
        this.setState({ isSubmittingCensus: true });
        const { quote } = this.state;
        const quoteId = this.state.quote.id;
        const fromQuoteId = this.state.quote.lastQuoteIDWithCensus;
        if (fromQuoteId) {
            censusApi.copyCensus(fromQuoteId, quoteId, null).then(response => {
                if (response.success) {
                    //We don't save at the "copy" point...  we ask the user to confirm the census.
                    if (response && response.census) {
                        quote.census = response.census;
                        quote.currentPlans = response.currentPlans || [];
                        quote.mappedPlans = response.mappedPlans || null;
                        quote.currentPlansRateType = response.currentPlansRateType || null;
                        quote.currentMedicalBasePlanId = response.currentMedicalBasePlanId || null;
                    }
                    this.setState({ isSubmittingCensus: false });
                    toast.success(response.message, { toastId: 1 });
                    /*quoteApi.submitQuote(quoteId)
                            .then(quoteResponse => {
                                this.props.setQuote(quoteResponse);
                                this._resetSelectedPlansAndSpreadsheets();
                                this.setState({
                                    quote: quoteResponse,
                                    step: step + 1,
                                    censusUpload: null,
                                    isSubmittingCensus: false,
                                    isReQuote: false,
                                });
                            })
                            .catch(err => {
                                if (err && err.response && err.response.data) {
                                    toast.error(err.response.data, { toastId: 2 });
                                } else if (err && err.response) {
                                    toast.error(err.response, { toastId: 2 });
                                }
                                this.setState({ isSubmittingCensus: false })
                            });
                        */
                } else {
                    if (response && response.message) {
                        toast.error(response.message, { toastId: 3 });
                    } else if (response && response.data) {
                        toast.error(response.data, { toastId: 3 });
                    }
                    this.setState({ isSubmittingCensus: false });
                }
            });
        }
    };

    _copyCensusU = () => {
        this.setState({ isSubmittingCensus: true });
        const { quote } = this.state;
        const quoteId = this.state.quote.id;
        const fromEnrollmentId = this.state.quote.lastEnrollmentIDWithCensus;
        if (fromEnrollmentId) {
            censusApi.copyCensusU(fromEnrollmentId, quoteId).then(response => {
                if (response.success) {
                    //We don't save at the "copy" point...  we ask the user to confirm the census.
                    if (response && response.census) {
                        quote.census = response.census;
                        quote.currentPlans = response.currentPlans || [];
                        quote.mappedPlans = response.mappedPlans || null;
                        quote.currentPlansRateType = response.currentPlansRateType || null;
                        quote.currentMedicalBasePlanId = response.currentMedicalBasePlanId || null;
                    }
                    this.setState({ isSubmittingCensus: false });
                    toast.success(response.message, { toastId: 1 });
                } else {
                    if (response && response.message) {
                        toast.error(response.message, { toastId: 3 });
                    } else if (response && response.data) {
                        toast.error(response.data, { toastId: 3 });
                    }
                    this.setState({ isSubmittingCensus: false });
                }
            });
        }
    };

    _subStepChanged = subStep => {
        this.setState(
            {
                subStep,
            },
            () => {
                window.scrollTo(0, 0);
            },
        );
    };

    _showReQuote = () => {
        this.setState({ showReQuoteModal: true });
    };

    _showCensus = () => {
        this.setState({ showCensusModal: true });
    };

    _gotoDetails = () => {
        const quoteId = this.state.quote.id;
        if (quoteId && quoteId > 0) {
            this.props.history.push(routeHelpers.quoteDetail(quoteId));
        }
    };

    _reset = () => {
        this.setState({
            step: 0,
            subStep: 0,
            isReQuote: true,
            showReQuoteModal: false,
            counties: [],
        });
    };

    render() {
        if (this.state.loading) {
            return null;
        }

        const { me } = this.props;
        const { quote, employerId, step, subStep, isReQuote, counties } = this.state;
        const showPlanTypeColumns =
            quote &&
            (quote.areaId === 32 || (quote.state && quote.state.toString().toUpperCase() === "CA"));

        const censusHeader = `Census: ${quote.censusSize} Employees, ${quote.censusEnrolling} Enrolling`;

        return (
            <div className={css(styles.content)}>
                <ToastContainer position="top-center" autoClose={3500} />
                <div className={css(styles.contentSection)}>
                    <div className={css(styles.titleSection)}>
                        {me.ratingEngineQuotePermission && step === 2 && (
                            <ReQuoteButton
                                aStyles={styles.reQuote}
                                onClick={this._showReQuote}
                                label={strings.reQuote}
                            />
                        )}
                        <PageTitle>
                            {step === 2
                                ? strings.quote
                                : isReQuote
                                ? strings.reQuote
                                : strings.newQuote}
                            {": "}
                            {step === 2 ? (
                                <span className={css(styles.titleLink)} onClick={this._gotoDetails}>
                                    {quote.quoteNumber}
                                </span>
                            ) : quote.id ? (
                                quote.quoteNumber
                            ) : null}
                            {step > 0 && quote.id && (
                                <span className={css(styles.groupNameText)}>
                                    &nbsp;|&nbsp;{quote.groupName}
                                    &nbsp;|&nbsp;{"Eff: "}
                                    {quote.effectiveDateString}
                                    &nbsp;|&nbsp;{quote.county && quote.county.trim() + " County, "}
                                    {quote.state} {quote.zip}
                                </span>
                            )}
                            {step > 1 && quote.censusEnrolling > 0 && (
                                <span className={css(styles.enrollingText)}>
                                    &nbsp;|&nbsp;
                                    <span
                                        className={css(styles.titleLink)}
                                        onClick={this._showCensus}
                                    >
                                        {quote.censusEnrolling}
                                        {" Enrolling"}
                                    </span>
                                </span>
                            )}
                        </PageTitle>
                    </div>
                    <div className={css(styles.headerSection)}>
                        {step < 2 && (
                            <div className={css(styles.backButtonContainer)}>
                                <button
                                    className={css(styles.backButton)}
                                    type="button"
                                    onClick={this._onBackButtonClick}
                                >
                                    <img
                                        src={backCircle}
                                        className={css(styles.backButtonImage)}
                                        alt="back"
                                    />
                                </button>
                            </div>
                        )}
                        <QuoteSteps step={step} subStep={subStep} />
                    </div>
                    <div className={css(styles.quoteForm)}>
                        {step === 0 && (
                            <FindCreateGroup
                                quote={quote}
                                employerId={employerId}
                                counties={counties}
                                saveQuote={this._saveQuote}
                                isSaving={this.state.isSaving}
                            />
                        )}
                        {step === 1 && (
                            <Census
                                quote={quote}
                                areaId={quote.areaId}
                                uploadCensus={this._uploadCensus}
                                copyCensus={this._copyCensus}
                                copyCensusU={this._copyCensusU}
                                isSaving={this.state.isSubmittingCensus}
                            />
                        )}
                        {step === 2 && (
                            <ProposalBuilder
                                subStep={subStep}
                                subStepChanged={this._subStepChanged}
                            />
                        )}
                    </div>
                </div>
                <Modal show={this.state.showReQuoteModal} header={strings.reQuote}>
                    <div className={css(styles.modalContent)}>
                        <div className={css(styles.modalInstructions)}>
                            {strings.reQuoteComment}
                            <br />
                            <br />
                            {strings.reQuoteQuestion}
                        </div>
                    </div>
                    <div className={css(styles.modalButtonContainer)}>
                        <ActionButton
                            aStyles={styles.modalButton}
                            label={strings.cancelButtonText}
                            invertColor={true}
                            type="button"
                            onClick={() => this.setState({ showReQuoteModal: false })}
                        />
                        <ActionButton
                            aStyles={styles.modalButton}
                            label={strings.yesButtonText}
                            onClick={this._reset}
                            type="button"
                        />
                    </div>
                </Modal>
                <Modal show={this.state.showCensusModal} header={censusHeader}>
                    <div className={css(styles.modalContent)}>
                        <div className={css(styles.modalTableContainer)}>
                            <table className={css(styles.table)}>
                                <thead>
                                    <tr>
                                        <td
                                            className={css(
                                                styles.tableHeader,
                                                styles.tableFirstColumn,
                                            )}
                                        >
                                            No.
                                        </td>
                                        <td className={css(styles.tableHeader)}>Rel</td>
                                        <td className={css(styles.tableHeader)}>Name</td>
                                        <td className={css(styles.tableHeader)}>DOB</td>
                                        <td className={css(styles.tableHeader)}>Age</td>
                                        <td className={css(styles.tableHeader)}>Gen</td>
                                        <td className={css(styles.tableHeader)}>Med</td>
                                        <td className={css(styles.tableHeader)}>Den</td>
                                        <td className={css(styles.tableHeader)}>Vis</td>
                                        <td className={css(styles.tableHeader)}>Lif</td>
                                        <td className={css(styles.tableHeader)}>H Zip</td>
                                        <td className={css(styles.tableHeader)}>State</td>
                                        <td className={css(styles.tableHeader)}>W Zip</td>
                                        <td className={css(styles.tableHeader)}>Title</td>
                                        <td className={css(styles.tableHeader)}>Salary</td>
                                        <td className={css(styles.tableHeader)}>Email</td>
                                        <td className={css(styles.tableHeader)}>Current Plan</td>
                                        <td className={css(styles.tableHeader)}>EE Eff Date</td>
                                        {showPlanTypeColumns ? (
                                            <td className={css(styles.tableHeader)}>PPO</td>
                                        ) : null}
                                        {showPlanTypeColumns ? (
                                            <td className={css(styles.tableHeader)}>HMO</td>
                                        ) : null}
                                        <td className={css(styles.tableHeader)}>COB</td>
                                        <td className={css(styles.tableHeader)}>Tob</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {quote.census
                                        ? quote.census.map(c => {
                                              return (
                                                  <tr
                                                      key={c.id}
                                                      className={
                                                          c.relationship === "EE" ? "" : "sub"
                                                      }
                                                  >
                                                      <td
                                                          className={css(
                                                              styles.tableRow,
                                                              styles.tableFirstColumn,
                                                              c.relationship === "EE"
                                                                  ? styles.greenBar
                                                                  : styles.blueBar,
                                                          )}
                                                      >
                                                          {c.sequenceNumber}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.relationship}
                                                      </td>
                                                      <td
                                                          className={css(
                                                              styles.tableRow,
                                                              styles.noWrap,
                                                          )}
                                                      >
                                                          {c.fullName}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.birthDateString}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.age}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.gender}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.medicalCoverage}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.dentalCoverage}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.visionCoverage}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.lifeCoverage}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.relationship === "EE"
                                                              ? c.homePostalCode
                                                              : this._getEmployeeHomeZipForRow(
                                                                    quote.census,
                                                                    c,
                                                                )}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.homeState}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.relationship === "C" &&
                                                          (c.dependentType !== "Spouse" ||
                                                              !c.dependentType) ? (
                                                              <div
                                                                  className={css(
                                                                      styles.dependentStatusContainer,
                                                                  )}
                                                              >
                                                                  <span
                                                                      className={css(
                                                                          styles.dependentStatusLabel,
                                                                      )}
                                                                  >
                                                                      Dependent Status
                                                                  </span>
                                                                  <span>
                                                                      {c.childDependentStatus ||
                                                                          "Child"}
                                                                  </span>
                                                              </div>
                                                          ) : (
                                                              c.workPostalCode
                                                          )}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.occupation}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.salary}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.email}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.currentMedicalPlanName}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.enrollmentDateString ||
                                                              c.enrollmentDate ||
                                                              ""}
                                                      </td>
                                                      {showPlanTypeColumns ? (
                                                          <td className={css(styles.tableRow)}>
                                                              {c.relationship === "EE"
                                                                  ? c.isPPO === null ||
                                                                    c.isPPO === undefined ||
                                                                    c.isPPO
                                                                      ? "Yes"
                                                                      : "No"
                                                                  : ""}
                                                          </td>
                                                      ) : null}
                                                      {showPlanTypeColumns ? (
                                                          <td className={css(styles.tableRow)}>
                                                              {c.relationship === "EE"
                                                                  ? c.isHMO === null ||
                                                                    c.isHMO === undefined ||
                                                                    c.isHMO
                                                                      ? "Yes"
                                                                      : "No"
                                                                  : ""}
                                                          </td>
                                                      ) : null}
                                                      <td className={css(styles.tableRow)}>
                                                          {c.onCobra ? "Yes" : "No"}
                                                      </td>
                                                      <td className={css(styles.tableRow)}>
                                                          {c.isTobacco ? "Yes" : "No"}
                                                      </td>
                                                  </tr>
                                              );
                                          })
                                        : null}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className={css(styles.modalCloseContainer)}>
                        {me.ratingEngineQuotePermission && (
                            <ActionButton
                                aStyles={styles.modalButton}
                                label={strings.closeButtonText}
                                invertColor={true}
                                type="button"
                                onClick={() => this.setState({ showCensusModal: false })}
                            />
                        )}
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    me: state.session.me,
});

export default connect(mapStateToProps, {
    setQuote: proposalActions.setQuote,
    setSelectedPlans: proposalActions.setSelectedPlans,
    setSpreadsheets: proposalActions.setSpreadsheets,
})(QuoteEditScreen);
